import { Box } from '@mui/material';
import MsSettingsTab from '../components/ms-settings/ms-settings-tab/msSettingsTab';

export default function MsSettings() {
  return (
    <Box>
      <MsSettingsTab />
    </Box>
  );
}
